import { ordersClient } from "@core/clients";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { queryClient } from "../../config/query-client";
import { TOrder } from "@core/types";
import { ORDERS_QUERY_CACHE_EXPIRE_TIME_MS } from "../../config/constansts";

const useGetOrderByIdQuery = (id: string, options?: UseQueryOptions<TOrder, any, TOrder, (string | undefined)[]>) => {
  return useQuery<TOrder, any, TOrder, (string | undefined)[]>(
    ["order", id],
    async () => {
      return await ordersClient.getOrderById(id);
    },
    {
      cacheTime: ORDERS_QUERY_CACHE_EXPIRE_TIME_MS,
      staleTime: ORDERS_QUERY_CACHE_EXPIRE_TIME_MS,
      initialData: () => {
        return queryClient.getQueryData<TOrder[]>(["orders"])?.find((order: TOrder) => order.id === id);
      },
      ...options,
    },
  );
};
export default useGetOrderByIdQuery;
